(function () {
    'use strict';

    angular.module("imApp").factory("metaTableDatasService", ['$ihttp', function ($ihttp) {
        let service = {
            listMetaTableDatas: function (parms) {
                return $ihttp.post({
                    method: 2385,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
